export function initAnimationHouses() {
    document.querySelectorAll('.animationHouse:not([data-ah-init])').forEach(el => {
        el.setAttribute('data-ah-init', '1');
        const frames = [...el.querySelectorAll('.animationHouse__frame')];
        const labels = [
            el.querySelector('.animationHouse__label--heat'),
            el.querySelector('.animationHouse__label--pv'),
            el.querySelector('.animationHouse__label--oil'),
        ];

        frames[0].classList.add('is-visible');

        const observer = new IntersectionObserver(([entry]) => {
            if (!entry.isIntersecting) return;
            observer.disconnect();
            runAnimation(frames, labels);
        }, { threshold: 0.2 });

        observer.observe(el);
    });
}

function runAnimation(frames, labels) {
    const FADE_MS = 300;
    const HOLD_MS = 800;
    let idx = 0;


    function step() {
        if (idx >= frames.length - 1) return;
        const out = frames[idx];
        const inn = frames[++idx];
        inn.classList.add('is-visible');
        setTimeout(() => out.classList.remove('is-visible'), FADE_MS);

        // label[0]=heat at idx1, label[1]=pv at idx2, label[2]=oil at idx3
        const label = labels[idx - 1];
        if (label) label.classList.add('is-visible');

        if (idx < frames.length - 1) setTimeout(step, FADE_MS + HOLD_MS);
    }

    setTimeout(step, HOLD_MS);
}
